"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MirEng = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MirEng = function MirEng(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M33.807 19.821h-9.769v5.08h3.098v-2.86h1.307l1.755 2.86h3.52l-2.067-3.1c.994-.355 1.782-1.077 2.156-1.98z",
    fill: "#064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.841 15.223c.014.259.052.511.109.756.014.055.026.11.041.164l.02.066a4.33 4.33 0 004.128 3.026h5.72a3.396 3.396 0 00-1.052-3.114 3.394 3.394 0 00-2.302-.898h-6.664z",
    fill: "url(#MirEng_svg__MirEng_svg__paint0_linear_28028_71992)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.604 16.495l-1.282 4.447h-.22l-1.284-4.447a1.76 1.76 0 00-1.69-1.273H6.05v9.68h3.08v-5.72h.22l1.76 5.72h2.2l1.76-5.72h.22v5.72h3.08v-9.68h-3.076a1.76 1.76 0 00-1.69 1.273zm6.088 8.406h3.08v-9.678h-3.08V24.9z",
    fill: "#064"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "MirEng_svg__MirEng_svg__paint0_linear_28028_71992",
    x1: 23.841,
    y1: 17.229,
    x2: 33.915,
    y2: 17.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3E91"
  }))));
};

exports.MirEng = MirEng;
var _default = MirEng;
exports.default = _default;